import React, { useState } from 'react';
import './PageStyles.css';

const PrivateEvents: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    eventType: '',
    guestCount: '',
    eventDate: '',
    message: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Event inquiry submitted:', formData);
    alert('Thank you for your inquiry! We\'ll contact you within 24 hours to discuss your event.');
    setFormData({ name: '', email: '', phone: '', eventType: '', guestCount: '', eventDate: '', message: '' });
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Private Events & Catering</h1>
        <p>Make your special occasions unforgettable</p>
      </div>

      <div className="events-container">
        <div className="events-info">
          <div className="event-types">
            <h2>Event Types</h2>
            <div className="types-grid">
              <div className="type-card">
                <h3>🎉 Birthday Parties</h3>
                <p>Celebrate in style with customized menus and dedicated service.</p>
              </div>
              <div className="type-card">
                <h3>👔 Corporate Events</h3>
                <p>Professional catering for meetings, presentations, and team building.</p>
              </div>
              <div className="type-card">
                <h3>💒 Wedding Receptions</h3>
                <p>Beautiful venues and exquisite cuisine for your special day.</p>
              </div>
              <div className="type-card">
                <h3>🎓 Graduations</h3>
                <p>Honor achievements with memorable dining experiences.</p>
              </div>
              <div className="type-card">
                <h3>👨‍👩‍👧‍👦 Family Reunions</h3>
                <p>Bring loved ones together with comfort food and warm hospitality.</p>
              </div>
              <div className="type-card">
                <h3>🏆 Celebrations</h3>
                <p>Any occasion worth celebrating deserves great food and service.</p>
              </div>
            </div>
          </div>

          <div className="services-section">
            <h2>Our Services</h2>
            <div className="services-list">
              <div className="service-item">
                <h3>Private Dining Room</h3>
                <p>Intimate space for up to 40 guests with dedicated staff and customized menu options.</p>
              </div>
              <div className="service-item">
                <h3>Full Restaurant Buyout</h3>
                <p>Exclusive use of our entire restaurant for larger celebrations up to 120 guests.</p>
              </div>
              <div className="service-item">
                <h3>Off-Site Catering</h3>
                <p>We bring our exceptional food and service to your chosen venue.</p>
              </div>
              <div className="service-item">
                <h3>Custom Menus</h3>
                <p>Work with our chef to create personalized menus for your event.</p>
              </div>
              <div className="service-item">
                <h3>Bar Service</h3>
                <p>Full bar service including signature cocktails and wine selections.</p>
              </div>
              <div className="service-item">
                <h3>Entertainment</h3>
                <p>Live music and entertainment options to enhance your celebration.</p>
              </div>
            </div>
          </div>

          <div className="packages-section">
            <h2>Sample Packages</h2>
            <div className="packages-grid">
              <div className="package-card">
                <h3>Casual Package</h3>
                <div className="package-price">$25/person</div>
                <ul>
                  <li>Appetizer selection</li>
                  <li>Choice of 2 entrees</li>
                  <li>Side dishes</li>
                  <li>Dessert</li>
                  <li>Non-alcoholic beverages</li>
                </ul>
              </div>
              <div className="package-card featured">
                <h3>Premium Package</h3>
                <div className="package-price">$45/person</div>
                <ul>
                  <li>Premium appetizer spread</li>
                  <li>Choice of 3 entrees</li>
                  <li>Gourmet side dishes</li>
                  <li>Dessert selection</li>
                  <li>Open bar (4 hours)</li>
                  <li>Dedicated server</li>
                </ul>
              </div>
              <div className="package-card">
                <h3>Deluxe Package</h3>
                <div className="package-price">$65/person</div>
                <ul>
                  <li>Chef's selection appetizers</li>
                  <li>Multi-course plated dinner</li>
                  <li>Premium sides</li>
                  <li>Gourmet dessert station</li>
                  <li>Premium open bar</li>
                  <li>Event coordinator</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="inquiry-form-section">
          <h2>Event Inquiry</h2>
          <form onSubmit={handleSubmit} className="event-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone">Phone *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="eventType">Event Type *</label>
                <select
                  id="eventType"
                  name="eventType"
                  value={formData.eventType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select event type</option>
                  <option value="birthday">Birthday Party</option>
                  <option value="corporate">Corporate Event</option>
                  <option value="wedding">Wedding Reception</option>
                  <option value="graduation">Graduation</option>
                  <option value="reunion">Family Reunion</option>
                  <option value="other">Other Celebration</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="guestCount">Number of Guests *</label>
                <input
                  type="number"
                  id="guestCount"
                  name="guestCount"
                  value={formData.guestCount}
                  onChange={handleChange}
                  min="1"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="eventDate">Preferred Date</label>
                <input
                  type="date"
                  id="eventDate"
                  name="eventDate"
                  value={formData.eventDate}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="message">Additional Details</label>
              <textarea
                id="message"
                name="message"
                rows={4}
                value={formData.message}
                onChange={handleChange}
                placeholder="Tell us more about your event, special requirements, budget, etc."
              ></textarea>
            </div>

            <button type="submit" className="submit-btn">Submit Inquiry</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PrivateEvents; 